
<div class="filterable-paginated-table-wrapper">
  <table class="table table-striped table-advance table-hover">
    <thead>
      <tr>
        <th
          *ngFor="let header of visibleColumns; index as i"
          [style.width]="getHeaderWidth(header, 'auto')"
        >
          <div class="filter-table-header" [attr.data-index]="i">
            <span class="label">{{ header.label }}</span>
            <div class="button-group">
              <button
                *ngIf="filters[i] && filters[i].value"
                class="btn btn-xs btn-gray btn-clear-filter"
                (click)="onClearFilterClick(header, i)"
              >
                <i class="fa fa-remove"></i>
              </button>
              <button
                *ngIf="header.filter && filters[i] && filters[i].property.length"
                class="btn btn-xs btn-gray btn-filter"
                [attr.data-index]="i"
              >
                <span class="icon-stack">
                  <i class="fa fa-filter icon-stack-base"></i>
                  <i *ngIf="filters[i] && filters[i].value" class="fa fa-check icon-checkmark"></i>
                </span>
              </button>
            </div>
            <div class="filter-input-height-limit">
              <div
                *ngIf="filters[i] && filters[i].property && filters[i].open"
                class="filter-input-wrapper"
                [attr.data-index]="i"
              >
                <input
                  [style.width]="'100%'"
                  type="text"
                  [attr.data-property]="filters[i].property.join('.')"
                  (change)="onFilterChange(header, i, $event)"
                  (keyup)="onFilterChange(header, i, $event)"
                  value="{{ filters[i].value }}"
                  class="form-control filter-input"
                />
              </div>
            </div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <tr
        *ngFor="let row of visibleRows; index as j"
        [ngClass]="{'empty-row': row === null}"
        [attr.data-row]="j"
        [attr.data-index]="paginationRowRange[0] + j"
      >
        <td
          *ngFor="let header of visibleColumns; index as i"
          [style.width]="getHeaderWidth(header, 'auto')"
        >
        <i *ngIf="header.isLoading && row" class="fa fa-circle-o-notch fa-spin"></i>
        <span *ngIf="!header.isLoading && (header.property.length !== 1 || header.property[0] !== 'actions' || !row)">{{ getValueFromRowAndPropertyArray(row, header.property) }}</span>
        <span *ngIf="!header.isLoading && (header.property.length === 1 && header.property[0] === 'actions' && row)" class="actions">
          <button *ngFor="let button of row.actions; index as buttonId" type="button" [ngClass]="'btn btn-xs ' + (button.class ? button.class : '')" (click)="onActionButtonClick(row, buttonId)">
            <i *ngIf="button.icon" [ngClass]="button.icon"></i>
            <span *ngIf="button.label">{{ button.label}}</span>
          </button>
        </span>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="loading">
      <tr>
        <td class="loading-cell" [attr.colspan]="visibleColumns.length"><div class="loading-wrapper"><i class="fa fa-circle-o-notch fa-spin fa-5x"></i></div></td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="!loading && paginationElements.length > 0" class="dataTables_paginate paging_bootstrap pagination">
    <ul>
      <li [ngClass]="{'prev': true, 'disabled': currentPageId === 0}"><a (click)="onPreviousPageClick()" class="fa fa-chevron-left"></a></li>
      <li *ngFor="let elem of paginationElements; index as index" [ngClass]="{'active': elem.action === 'active', 'disabled': elem.action !== 'active' && !elem.enabled}">
        <a *ngIf="elem.content.type === 'label'" [attr.data-action]="elem.action" (click)="onPageClick(elem, index)">{{ elem.content.label  }}</a>
        <a *ngIf="elem.content.type === 'icon'" [ngClass]="elem.content.icon" (click)="onPageClick(elem, index)"></a>
      </li>
      <li [ngClass]="{'next': true, 'disabled': currentPageId === pageCount - 1}"><a (click)="onNextPageClick()" class="fa fa-chevron-right"></a></li>
    </ul>
  </div>
</div>
